import ContentCard from "../../../components/misc/ContentCard";
import CustomButton from "../../../components/CustomButton";
import InternodeRoutes from "../InternodeRoutes";
import { useNavigate } from "react-router-dom";
import { expeditionRoutes } from "../../../router/routesConstants";

function RoutesOrganizationInternode() {
  const navigate = useNavigate();

  const handleButtonPress = () => {
    navigate(`/${expeditionRoutes.routesOrganizationLocal}`);
  };

  return (
    <>
      <ContentCard cardBodyClassName="flex">
        <CustomButton
          variant={"outlined"}
          className="min-w-0 flex-1"
          style={{ borderEndEndRadius: 0, borderStartEndRadius: 0 }}
          onClick={handleButtonPress}>
          Rute locale
        </CustomButton>
        <CustomButton
          variant={"contained"}
          className="min-w-0 flex-1"
          style={{ borderEndStartRadius: 0, borderStartStartRadius: 0 }}>
          Rute internod
        </CustomButton>
      </ContentCard>

      <InternodeRoutes />
    </>
  );
}

export default RoutesOrganizationInternode;
